import { inject, observer } from "mobx-react";
import * as moment from 'moment-timezone';
import * as React from "react";
import { withRouter } from "react-router";
import { Col } from "reactstrap";
import DataTable from "src/Components/DataTable";
import { ITest } from "src/Interfaces/TestInterface";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";

@inject('stores')
@observer
class IntervalViewTable extends React.Component {
    public props: any;
    private WellsStore: WellsStore;
    private TestsStore: TestsStore;
    constructor(props: any) {
        super(props);
        this.WellsStore = props.stores.WellsStore;
        this.TestsStore = props.stores.TestsStore;
    }

    public componentDidMount() {
        if (!this.TestsStore.test
            || !this.TestsStore.tests
            || !this.TestsStore.tests[0]
            || this.TestsStore.test.id !== this.TestsStore.tests[0].id)
            {
                if (!this.TestsStore.tests) {

                    this.TestsStore.getTests(this.props.match.params.wellId)
                    .then(data => {
                        if (data) {
                            this.TestsStore.getTestDetails(this.TestsStore.tests[0].id, this.props.match.params.wellId);
                        }
                    });
                } else {
                    this.TestsStore.getTestDetails(this.TestsStore.tests[0].id, this.props.match.params.wellId);
                }
            }
    }

    private renderIntervalTableData = (test: ITest) => {
        const intervals = test.intervals;

        const headers = [
            'Interval',
            'Sub Interval',
            'Top of Interval MD (ft)',
            'Top of Interval TVD (ft)',
            'Depth MD (ft)',
            'Depth TVD (ft)',
            'Plug Back Depth MD (ft)',
            'Interval Start',
            'Interval Stop',
        ];

        const rows = intervals.map(interval => [
            {
                content: interval.intervalType
            },
            {
                content: interval.subInt
            },
            {
                content: interval.topFt
            },
            {
                content: interval.topFtTVD
            },
            {
                content: interval.bottomFt
            },
            {
                content: interval.depthTVD
            },
            {
                content: interval.plugBackDepth
            },
            {
                content: interval.startDate !== '' ? moment.unix(Number(interval.startDate)).tz(this.WellsStore.well.timeZoneName).format("MMM DD YYYY") : ''
            },
            {
                content: interval.stopDate !== '' ? moment.unix(Number(interval.stopDate)).tz(this.WellsStore.well.timeZoneName).format("MMM DD YYYY") : ''
            }
        ]);

        return {
            headers,
            rows
        };
    }

    public render() {
        const wellCloseReview = this.WellsStore.wellCloseReview;
        const lastTest = this.TestsStore.test;
        const well = this.WellsStore.well;
        if (wellCloseReview === undefined || lastTest === undefined || well === undefined) {
            return '';
        }
        return <Col>
            <DataTable
                list={this.renderIntervalTableData(lastTest)}
            />
        </Col>;
    }
}

export default withRouter(IntervalViewTable);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellClose/IntervalViewTable.tsx